export const ConfirmDialog = ({
    selectedAppointment,
    formatDate,
    handleUpdate,
    loading,
    notify,
}) => {
    return (
        <div className="p-16 bg-white sm:min-w-[60dvw]">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2 text-center">
                Confirmación de turno
            </h2>
            <h3 className="text-lg text-gray-500 text-center mb-12">
                Aquí puedes confirmar o cancelar tu turno
            </h3>
            {loading && (
                <div className="flex items-center justify-center space-x-2">
                    <div className="w-5 h-5 border-2 border-gray-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
            )}
            {selectedAppointment && (
                <div className="bg-gray-100 p-12 pb-40 flex-col md:flex-row gap-8 flex justify-between w-full mb-12 rounded-lg">
                    <div className="flex flex-col">
                        <strong className="text-gray-500">Paciente</strong>
                        <span className="font-semibold">
                            {selectedAppointment.patient.firstName}{" "}
                            {selectedAppointment.patient.lastName}
                        </span>
                    </div>
                    <div className="flex flex-col">
                        <strong className="text-gray-500">Médico</strong>
                        <span className="font-semibold">
                            {selectedAppointment.doctor.firstName}{" "}
                            {selectedAppointment.doctor.lastName}
                        </span>
                    </div>
                    <div className="flex flex-col">
                        <strong className="text-gray-500">Fecha y hora</strong>
                        <span className="font-semibold">
                            {formatDate(selectedAppointment.date)} |{" "}
                            {selectedAppointment.time
                                ? selectedAppointment.time
                                : "Hora a confirmar"}
                        </span>
                    </div>
                </div>
            )}

            {selectedAppointment?.status < 3 ? (
                <div className="flex flex-col md:flex-row justify-center gap-3">
                    <button
                        disabled={loading}
                        onClick={() => handleUpdate({ status: 4, time: null, unscheduled: true })}
                        className="px-8 py-2 rounded bg-transparent text-red-500 hover:bg-gray-200 transition-all disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        disabled={loading}
                        onClick={() => handleUpdate({ status: 3 })}
                        className="px-8 py-2 rounded-lg bg-green-100 text-green-700 border border-green-700 font-semibold hover:bg-green-300 transition-all disabled:opacity-50"
                    >
                        Confirmar turno
                    </button>
                </div>
            ) : (
                <p className="text-lg font-bold text-gray-900 text-center mb-12">
                    Usted ha{" "}
                    {selectedAppointment?.status === 4 ? (
                        <span>
                            <span className="text-red-600">Cancelado</span> su
                            turno
                        </span>
                    ) : (
                        <span>
                            <span className="text-green-600">Confirmado</span>{" "}
                            su turno{" "}
                        </span>
                    )}
                </p>
            )}
        </div>
    );
};
